import * as React from 'react'

import Button, { ButtonProps } from '@material-ui/core/Button'
import Grid                    from '@material-ui/core/Grid'
import { InjectedFormikProps } from 'formik'
import { FormattedMessage }    from 'react-intl'
import styled                  from 'styled-components'

import { InjectedStepperProps } from '../../organisms'

interface StepFormWrapperProps extends InjectedFormikProps<any, any>, InjectedStepperProps {
  children: React.SFC<object>
}

interface PreviousProps extends ButtonProps {
  opacity: 1 | 0
}

const NavigationWrapper = styled.div`
  padding: 24px 0 0 0;
`

const Previous = styled(Button)`
  opacity: ${(props: PreviousProps) => props.opacity};
`

const StepFormWrapper: React.SFC<StepFormWrapperProps> = (props) => {
  const {
    handleSubmit,
    isValid,
    goToPrevious,
    isFirstStep,
    isLastStep,
    children,
    ...rest
  } = props
  const phrasing = {
    register:
      (
        <FormattedMessage id={'buttonActions.register'} />
      ),

    previous:
      (
        <FormattedMessage
          id={'buttonActions.previous'}
          defaultMessage={'previous'}
        />
      ),

    next:
      (
        <FormattedMessage
          id={'buttonActions.next'}
          defaultMessage={'next'}
        />
      ),
  }

  const submitMessage = isLastStep
    ? phrasing.register
    : phrasing.next

  return (
    <form style={{ padding: '24px', height: '100%' }} onSubmit={handleSubmit}>
      <Grid
        container
        spacing={24}
        direction={'column'}
        style={{ height: 'calc(100% - 72px)' }}
        wrap={'nowrap'}
      >
        <Grid
          item
          style={{
            flex:      1,
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
        >
          {children(rest)}
        </Grid>
        <Grid item>
          <NavigationWrapper>
            <Grid container justify={'space-between'}>
              <Previous
                opacity={!isFirstStep ? 1 : 0}
                disabled={isFirstStep}
                onClick={() => goToPrevious(rest.values)}
                variant={'raised'}
                color={'secondary'}
              >
                {phrasing.previous}
              </Previous>
              <Button
                type={'submit'}
                variant={'raised'}
                color={'primary'}
              >
                {submitMessage}
              </Button>
            </Grid>
          </NavigationWrapper>
        </Grid>
      </Grid>
    </form>
  )
}

export default StepFormWrapper



// WEBPACK FOOTER //
// ./src/components/forms/wrappers/StepFormWrapper.tsx